import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18CheckmarkG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h18v18H0z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M13.323 3.574a.8.8 0 0 1 1.406.757l-.052.095-6.301 10a.8.8 0 0 1-1.248.135l-.071-.084-3.7-4.984a.8.8 0 0 1 1.215-1.036l.07.083 3.003 4.045z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18CheckmarkG$1 = Svg18CheckmarkG;

export { Svg18CheckmarkG$1 as default };
